import type { TFunction } from 'i18next';
import type { PermissionEnum } from '@shared/api';

export const CLEAR_VALUE = '__CLEAR__';

export const buildAccessRights = (
  t: TFunction<'translation', 'team'>,
): Record<PermissionEnum, { title: string; description: string }> => ({
  OWNER: {
    title: t('roles.owner'),
    description: t('roles.ownerDescription'),
  },
  ADMIN: {
    title: t('roles.admin'),
    description: t('roles.adminDescription'),
  },
  MANAGER: {
    title: t('roles.manager'),
    description: t('roles.managerDescription'),
  },
});

export const PERMISSION_COLORS: Record<PermissionEnum, string> = {
  MANAGER: '#FAAD14',
  ADMIN: '#13C2C2',
  OWNER: '#1677FF',
};
